<div class="skeleton-wrapper">
  @for (skeleton of skeletons(); track index; let index = $index) {
    <div class="skeleton">
      <div class="skeleton__thumbnail"></div>
      <div class="skeleton__name"></div>
      <div class="skeleton__date"></div>
      <div class="skeleton__description"></div>
    </div>
  }
</div>
